<template>
    <div class="skeleton-index skeleton-el">
        <div class="block1">
            <div class="left block">
            </div>
            <div class="right">
                <div class="top">
                    <div class="block"></div>
                    <div class="block"></div>
                </div>
                <div class="bottom">
                    <div class="block"></div>
                    <div class="block"></div>
                </div>
            </div>
        </div>
        <ul class="block2">
            <li><div class="block"></div><div class="block"></div></li>
            <li><div class="block"></div><div class="block"></div></li>
            <li><div class="block"></div><div class="block"></div></li>
            <li><div class="block"></div><div class="block"></div></li>
            <li><div class="block"></div><div class="block"></div></li>
        </ul>
        <ul class="block3">
            <li class="block"></li>
            <li class="block"></li>
            <li class="block"></li>
            <li class="block"></li>
        </ul>
        <div class="block4 block"></div>
        <div class="fetch-loading"><img src="../fetchLoading/imgs/icon3.png"></div>
    </div>
</template>
<script>
export default {
  name: 'SkeletonIndex',
};
</script>
<style lang="scss" scoped>
.skeleton-index {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    padding: 130px 30px 0;
    background: #fff;
    .block {
        background: #F0F0F0;
    }
    .block1 {
        display: flex;
        .left {
            width: 190px;
            height: 240px;
            margin-right: 20px;
        }
        .right {
            width: 480px;
            div {
                height: 110px;
            }
            .top {
                @include SpaceBetween();
                div:first-child {
                    width: 260px;
                }
                div:last-child {
                    width: 200px;
                }
            }
            .bottom {
                @include SpaceBetween();
                margin-top: 20px;
                div:first-child {
                    width: 160px;
                }
                div:last-child {
                    width: 300px;
                }
            }
        }
    }
    .block2 {
        @include SpaceBetween();
        margin-top: 32px;
        li {
            div:first-child {
                width: 70px;
                height: 66px;
                margin: 0 auto;
            }
            div:last-child {
                width: 106px;
                height: 28px;
                margin-top: 10px;
                border-radius: 14px;
            }
        }
    }
    .block3 {
        display: flex;
        margin-top: 51px;
        li {
            width: 126px;
            height: 36px;
            margin-left: 40px;
            border-radius: 18px;
            &:first-child {
                width: 112px;
                height: 60px;
                margin-left: 0;
                border-radius: 30px;
            }
        }
    }
    .block4 {
        width: 690px;
        height: 88px;
        margin: 30px auto 0;
    }
}
</style>
